import { render, staticRenderFns } from "./eeg.vue?vue&type=template&id=588c7bec&scoped=true"
import script from "./eeg.vue?vue&type=script&lang=js"
export * from "./eeg.vue?vue&type=script&lang=js"
import style0 from "./eeg.vue?vue&type=style&index=0&id=588c7bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588c7bec",
  null
  
)

export default component.exports